import { useContext } from "react";
import { WellContext } from "../context/WellContext";
import TransmitterFaceplate from "./TransmitterFaceplate";

import { useState, useEffect } from "react";



function Valve({
  tag,
  x,
  y,
  isClosed,
  toggle,
  r = 0,
  scale = 1
}) {

  const [hover, setHover] = useState(false);
  const [showFaceplate, setShowFaceplate] = useState(false);

    useEffect(() => {
        localStorage.setItem(tag, isClosed ? 0 : 1);
    }, [tag, isClosed]);



  return (

    <>
    
      {/* ================= FLOATING TAG ================= */}

      {hover && (

        <div
          style={{
            position: "absolute",

            left: x - 15,
            top: y - 25,

            background: "black",

            color: "lime",

            border: "2px solid cyan",

            borderRadius: "6px",

            padding: "2px 5px",

            fontSize: "12px",
            fontWeight: "bold",

            zIndex: 9999,

            pointerEvents: "none",

            whiteSpace: "nowrap",

            boxShadow: "0 0 10px cyan"
          }}
        >
          {tag}
        </div>
      )}

      {/* ================= VALVE SVG ================= */}

      <svg
        width="35"
        height="42"
        viewBox="0 0 220 220"

        style={{
          position: "absolute",

          left: x,
          top: y,

          cursor: "pointer",

          transition: "0.5s ease",

          filter: hover
            ? isClosed
              ? "drop-shadow(0 0 8px lime)"
              : "drop-shadow(0 0 8px red)"
            : "none",

          transform: hover
            ? `rotate(${r}deg) scale(${scale * 1.05})`
            : `rotate(${r}deg) scale(${scale})`,
        }}

        onClick={() => toggle(tag)}

        onDoubleClick={(e) => {
            e.stopPropagation();
            setShowFaceplate(true);
        }}

        onMouseEnter={() => setHover(true)}

        onMouseLeave={() => setHover(false)}
      >

        <g>

          <rect
            x="0"
            y="0"
            width="220"
            height="80"

            stroke="black"
            strokeWidth="2"

            fill={isClosed ? "red" : "lime"}
          />

          <rect
            x="107"
            y="80"
            width="15"
            height="60"

            stroke="black"
            strokeWidth="2"

            fill={isClosed ? "red" : "lime"}
          />

          <polygon
            points="0,210 110,140 0,100"

            stroke="black"
            strokeWidth="2"

            fill={isClosed ? "red" : "lime"}
          />

          <polygon
            points="220,210 110,140 220,100"

            stroke="black"
            strokeWidth="2"

            fill={isClosed ? "red" : "lime"}
          />

        </g>

      </svg>


      {showFaceplate && (
          <TransmitterFaceplate
              tag={tag}
              value={isClosed ? 0 : 1}
              unit=""
              min={0}
              max={1}
              HH={1}
              H={1}
              L={0}
              LL={0}
              description="Shutdown Valve Position"
              x={x + 40}
              y={y + 30}
              onClose={() => setShowFaceplate(false)}
          />
      )}


      

    </>
  );
}

export default Valve;